
import { ddLLL } from "@/helpers/dateHelper";
import { DirectionEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent } from "vue";
import TripCalendar from "../bookingflow/steps/tripdetails/TripCalendar.vue";
import TripType from "../bookingflow/steps/tripdetails/TripType.vue";
import QuickformInput from "./QuickformInput.vue";

export default defineComponent({
	components: { TripCalendar, QuickformInput, TripType },
	setup(props, { emit }) {
		const bookingStore = useBookingStore();
		
		const dateChanged = () => {
			emit('dateChanged')
		};
		
		const formatDate = (date?: Date) => {
			if (date) {
				return ddLLL(date);
			}
			return "";
		};

		const value = computed(() => {
			if (bookingStore.getBooking.tripType === DirectionEnum.Return) {
				return `${formatDate(
					bookingStore.getBooking.outward.date
				)} - ${formatDate(bookingStore.getBooking.return.date)}`;
			} else {
				return `${formatDate(bookingStore.getBooking.outward.date)}`;
			}
		});

		return { value, dateChanged };
	},
});
